/**
 * drawerDraggerStyle
 *
 * Style for antd Drawer's `dragger` semantic slot, turning the invisible resize
 * strip into the grip the RecordsBrowser divider draws: a bordered track holding
 * a centred bar. Consumers are every resizable Drawer, which pass it as
 * `styles={{ dragger: drawerDraggerStyle(token) }}`. The bar is painted as a
 * background image, and its two colours are handed to CSS as custom properties,
 * so the `.ant-drawer-resizable-dragger` rules in `index.css` can swap the
 * resting colour for the active one on hover and drag without fighting this
 * inline style. `opacity` and `backgroundColor` are pinned because antd's own
 * hover rule dims the whole strip and tints it, which would hide the grip.
 */

import type { CSSProperties } from 'react';
import type { GlobalToken } from 'antd';

const TRACK_WIDTH = 6;
const GRIP_WIDTH = 3;
const GRIP_HEIGHT = 40;

type DrawerDraggerStyle = CSSProperties & {
  '--drawer-dragger-grip': string;
  '--drawer-dragger-grip-active': string;
};

export const drawerDraggerStyle = (token: GlobalToken): DrawerDraggerStyle => ({
  width: TRACK_WIDTH,
  cursor: 'ew-resize',
  opacity: 1,
  backgroundColor: 'transparent',
  backgroundPosition: 'center',
  backgroundSize: `${GRIP_WIDTH}px ${GRIP_HEIGHT}px`,
  backgroundRepeat: 'no-repeat',
  borderInlineStart: `1px solid ${token.colorBorderSecondary}`,
  '--drawer-dragger-grip': token.colorTextQuaternary,
  '--drawer-dragger-grip-active': token.colorPrimary,
});
